import AsyncReactSelect from 'react-select/async';
import createSelect from './createSelect';
var AsyncSelect = createSelect(AsyncReactSelect);
export default AsyncSelect;